const PromoDeal = {
    EXPRESS_DEAL: 'EXPRESS_DEAL',
    NHA: 'NHA'
};
const GEO = 'GEO';
const HOTEL_DEFAULT_VALUES = {
    endLocation: null,
    startLocation: null,
    startDate: '',
    endDate: '',
    tripType: 'STAY',
    mapView: false
};
const HOTEL_LABELS = {
    endLocation: 'Where to?',
    startLocation: 'Where from?',
    datePicker: 'Check-in - Check-out',
    backButton: 'List View'
};
const LISTINGS_DATE_PICKER_CUSTOM_FORMAT = 'MM/dd/yyyy';
export { GEO, HOTEL_DEFAULT_VALUES, HOTEL_LABELS, LISTINGS_DATE_PICKER_CUSTOM_FORMAT, PromoDeal };
